module.exports = __webpack_public_path__ + "static/media/google_text.61ca4715.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/google_text.svg
// module id = 368
// module chunks = 0